export const DELETE_CHANNEL_SUCCESS = 'DELETE_CHANNEL_SUCCESS'
export const DELETE_ADMIN_CHANNEL_SUCCESS = 'DELETE_ADMIN_CHANNEL_SUCCESS'
export const CHANNEL_FETCHED = 'CHANNEL_FETCHED'
export const CHANNELS_FETCHED = 'CHANNELS_FETCHED'
export const ADMIN_CHANNEL_FETCHED = 'ADMIN_CHANNEL_FETCHED'
export const CHANGE_CHANNEL_NAME_START = 'CHANGE_CHANNEL_NAME_START'
export const CHANGE_CHANNEL_NAME_SUCCESS = 'CHANGE_CHANNEL_NAME_SUCCESS'
export const CHANGE_CHANNEL_NAME_ERROR = 'CHANGE_CHANNEL_NAME_ERROR'
